import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useDrag } from "react-dnd";
import session from "../services/session";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  swalDeleteForm,
  swalDuplicateForm,
  swalError,
  swalSuccess,
  swalInfo,
} from "../utils/swal";
import projectService from "../services/project";
import moodboardService from "../services/moodboard";
import "../css/project-box.css";
import { Button, Dropdown, Input, Modal, Spin, Tag, Menu as MenuAntd } from "antd";
import styled from "styled-components";
import Avatar from "react-avatar";
import { DownOutlined, FolderOutlined } from "@ant-design/icons";

function ProjectBox(props) {
  const navigate = useNavigate();
  const [isCollaborator, setIsCollaborator] = useState(false);
  // const [accessType, setAccessType] = useState(1);
  const [defaultImage, setDefaultImage] = useState(getRandomDefaultImage());
  const [showModalAddTags, setShowModalAddTags] = useState(false);
  const [tags, setTags] = useState([]);
  const [colorTag, setColorTag] = useState("#F3F3F3");
  const [colorTagEdit, setColorTagEdit] = useState("#F3F3F3");
  const [value, setValue] = useState("");
  const [visibleColor, setVisibleColor] = useState(false);
  const [visibleColor2, setVisibleColor2] = useState(false);
  const [editMode, setEditMode] = useState({
    status: false,
    index: 0,
  });
  const [edited, setEdited] = useState(false);
  const [showThumbnailModal, setShowThumbnailModal] = useState(false);
  const [showAddToProject, setShowAddToProject] = useState(false);
  const [userProjects, setUserProjects] = useState([]);
  const [addingToProject, setAddingToProject] = useState(false);
  const thumbnailInputRef = useRef(null);

  useEffect(() => {
    if (session.get("user") && session.get("user")._id) {
      // eslint-disable-next-line array-callback-return
      props.project.collaborations.map((collaboration) => {
        if (collaboration.email === session.get("user").email) {
          setIsCollaborator(true);
          // setAccessType(collaboration.type);
        }
      });
    }
    getDefaultImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getVideoId(url) {
    let videoId = null;

    // Check if it's a shortened YouTube URL
    if (url.includes("youtu.be")) {
      videoId = url.split("youtu.be/")[1];
    }
    // Check if it's a standard YouTube URL
    else if (url.includes("youtube.com")) {
      const urlParams = new URL(url).searchParams;
      videoId = urlParams.get("v");
    }

    return videoId;
  }

  function getRandomDefaultImage(){
    let imageURLs = ["https://cdn.midjourney.com/a27f9c9a-241d-4d66-a241-06d4ea3a30b2/0_1.png","https://cdn.midjourney.com/a27f9c9a-241d-4d66-a241-06d4ea3a30b2/0_1.png", "https://cdn.midjourney.com/c59c2656-780d-4add-9c2d-f1b02d86169f/0_0.png","https://cdn.midjourney.com/c59c2656-780d-4add-9c2d-f1b02d86169f/0_3.png"]
    let i = Math.floor(Math.random() * imageURLs.length);
    return imageURLs[i];
  }

  const getDefaultImage = () => {
    console.log(props.project.moodboards.length);
    if (props.project.moodboards.length === 0) {
      setDefaultImage(getRandomDefaultImage());
      return;
    }
    if (
      !props.project.defaultThumbnail ||
      props.project.defaultThumbnail === "null"
    ) {
      props.project.moodboards.forEach((element) => {
        console.log("element: ", element);
        if (element?.thumbnailUrl && element?.thumbnailUrl !== "null") {
          console.log(element.thumbnailUrl);
          setDefaultImage(element.thumbnailUrl);
          return;
        }
        if (element.fileUrl.includes("www.youtube.com")) {
          const videoId = getVideoId(element.fileUrl);
          if (videoId) {
            setDefaultImage(
              `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
            );
            return;
          }
        }
      });
    } else {
      setDefaultImage(props.project.defaultThumbnail);
    }
  };

  // const handleEdit = () => {
  //   if (props.project.userId !== session.get("user")._id) {
  //     if (accessType === 1) {
  //       swalInfo(`You don't have permission to edit the project.`);
  //       return;
  //     }
  //   }

  //   navigate(`/project/${props.project._id}`);
  // };

  // const handleOpen = () => navigate(`/projects/${props.project._id}`);
  // const handleOpen = () => navigate(`/view/${props.project._id}`);
  const handleOpen = () => navigate(`/n/${props.project._id}`, {
    state: { fromTab: props.currentTab },
  });

  const handleDelete = (e) => {
    e.preventDefault();

    if (props.project.userId !== session.get("user")._id) {
      swalInfo(`Only project owner can delete the project.`);
      return;
    }

    swalDeleteForm(async () => {
      await projectService.delete(props.project._id).then((result) => {
        if (result.error) {
          swalError(result.error);
          return;
        }

        swalSuccess("Project deleted successfully!");
        props.reload();
      });
    });
  };

  const handleDuplicate = (e) => {
    e.preventDefault();

    if (props.project.userId !== session.get("user")._id) {
      swalInfo(`Only project owner can duplicate the project.`);
      return;
    }

    swalDuplicateForm(async () => {
      await projectService.duplicate(props.project._id).then((result) => {
        if (result.error) {
          swalError(result.error);
          return;
        }
        swalSuccess("Project duplicated successfully!");
        props.reload();
      });
    });
  };

  const handleThumbnailUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const result = await projectService.updateThumbnail(props.project._id, file);
    if (result.error) {
      swalError(result.error);
    } else {
      setDefaultImage(URL.createObjectURL(file));
    }
    e.target.value = "";
  };

  const handleSelectAssetThumbnail = async (url) => {
    const result = await projectService.updateThumbnailFromUrl(props.project._id, url);
    if (result.error) {
      swalError(result.error);
    } else {
      setDefaultImage(url);
      setShowThumbnailModal(false);
    }
  };

  const getAssetImages = () => {
    return props.project.moodboards
      .map((m) => {
        if (m.thumbnailUrl && m.thumbnailUrl !== "null") return m.thumbnailUrl;
        if (m.type === "image" && m.fileUrl) return m.fileUrl;
        if (m.fileUrl && m.fileUrl.includes("youtube.com")) {
          const videoId = getVideoId(m.fileUrl);
          if (videoId) return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        }
        return null;
      })
      .filter(Boolean);
  };

  const handleOpenAddToProject = async () => {
    setShowAddToProject(true);
    if (userProjects.length === 0) {
      const result = await projectService.getAll("", []);
      if (result.data) setUserProjects(result.data);
    }
  };

  const handleAddToProject = async (targetProjectId) => {
    setAddingToProject(true);
    const result = await moodboardService.copyToProject(
      props.project._id,
      targetProjectId
    );
    if (result.data) {
      swalSuccess(`${result.data.count} asset${result.data.count !== 1 ? "s" : ""} added to project`);
    } else {
      swalError(result.error || "Failed to add assets");
    }
    setAddingToProject(false);
    setShowAddToProject(false);
  };

  const hanldeAddTags = async (e) => {
    e.preventDefault();
    setEdited(true);

    if (props.project.userId !== session.get("user")._id) {
      swalInfo(`Only project owner can add tags the project.`);
      return;
    }

    let newTag = {};
    if (value) {
      newTag = {
        name: value,
        color: colorTag,
        userId: session.get("user")._id,
      };
    }

    await projectService.addTags(props.project._id, newTag).then((result) => {
      if (result.error) {
        swalError(result.error);
        return;
      }

      swalSuccess("Add tag successfully!");
      setValue("");
      props.setData((prev) => {
        const newData = [...prev];
        const index = newData.findIndex(
          (item) => item._id === props.project._id
        );
        newData[index]?.tags.push({
          name: result.data.name,
          color: result.data.color,
          _id: result.data._id,
        });
        return newData;
      });
    });
  };

  const handleEditTag = async (id, name, color) => {
    setEdited(true);

    await projectService.editTag(id, { name, color }).then((result) => {
      if (result.error) {
        swalError(result.error);
        return;
      }
      setEditMode({ status: false, index: 0 });
      swalSuccess("Tag edited successfully!");
      props.setData((prev) => {
        const newData = [...prev];

        const index = newData.findIndex(
          (item) => item._id === props.project._id
        );

        const indexTag = newData[index]?.tags.findIndex(
          (tag) => tag._id === id
        );
        const newTags = [...newData[index]?.tags] || [];

        newTags[indexTag] = {
          _id: result.data._id,
          name: result.data.name,
          color: result.data.color,
        };

        newData[index].tags = [...newTags];

        return newData;
      });
    });
  };

  const handleRemoveTag = async (id) => {
    setEdited(true);

    if (props.project.userId !== session.get("user")._id) {
      swalInfo(`Only project owner can edit tags the project.`);
      return;
    }

    await projectService.deleteTag(id).then((result) => {
      if (result.error) {
        swalError(result.error);
        return;
      }
      swalSuccess("Tag deleted successfully!");
      props.setData((prev) => {
        const newData = [...prev];
        const index = newData.findIndex(
          (item) => item._id === props.project._id
        );
        newData[index].tags = newData[index].tags.filter(
          (tag) => tag._id !== id
        );

        return newData;
      });
    });
  };

  const parseTitle = (title) => {
    if (/^\s*$/.test(title)) {
      return "Untitled";
    }
    return title;
  };

  const defaultImageStyle = {
    backgroundImage: "url(" + defaultImage + ")",
    width: "100%",
    height: "180px",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const emptyDefaultImageStyle = {
    backgroundColor: "#18181b",
    width: "100%",
    height: "180px",
  };

  const colorList = ["#6F47E0", "#47C4E0", "#E04775", "#F3F3F3", "#191B1F"];

  const selectColor = (
    <div
      style={{
        width: "fit-content",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        backgroundColor: "#2c2c2c",
        borderRadius: "4px",
      }}
    >
      {colorList.map((color) => (
        <div
          onClick={() => {
            setVisibleColor(false);
            setColorTag(color);
          }}
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: `2px solid ${color}`,
            cursor: "pointer",
          }}
        />
      ))}
    </div>
  );
  const selectColor2 = (
    <div
      style={{
        width: "fit-content",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        backgroundColor: "#2c2c2c",
        borderRadius: "4px",
      }}
    >
      {colorList.map((color) => (
        <div
          onClick={() => {
            setVisibleColor2(false);
            setColorTagEdit(color);
          }}
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: `2px solid ${color}`,
            cursor: "pointer",
          }}
        />
      ))}
    </div>
  );

  useEffect(() => {
    if (showModalAddTags) {
      if (props?.project?.tags?.length > 0) {
        setTags(
          props.project.tags?.map((tag) => ({
            name: tag.name,
            color: tag.color,
            _id: tag._id,
          }))
        );
      } else {
        setTags([]);
      }
    }
  }, [props, showModalAddTags]);

  const isList = props.viewMode === "list";
  const isDiscover = props.currentTab === "discover";
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselImages = useMemo(() => getAssetImages(), [props.project.moodboards]);

  const handleCarouselPrev = (e) => {
    e.stopPropagation();
    setCarouselIndex((prev) => (prev > 0 ? prev - 1 : carouselImages.length - 1));
  };
  const handleCarouselNext = (e) => {
    e.stopPropagation();
    setCarouselIndex((prev) => (prev < carouselImages.length - 1 ? prev + 1 : 0));
  };

  // Dragging a card that belongs to the current selection drags the whole
  // selection; dragging an unselected card drags just that one.
  const [{ isDragging }, dragRef] = useDrag({
    type: "PROJECT",
    item: () => {
      const id = props.project._id;
      const batch =
        props.selected && props.selectedProjectIds && props.selectedProjectIds.length
          ? props.selectedProjectIds
          : [id];
      return { projectId: id, projectIds: batch };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Intercept clicks before the inner open/action handlers see them, so a
  // modifier-click (or a click while a selection is active) selects instead of
  // navigating. Clicks on the card's own action buttons are left alone.
  const handleCardClickCapture = (e) => {
    if (!props.onCardClick) return;
    if (
      e.target.closest(
        ".project-box-actions, .project-box-list-actions, .add-to-project-dropdown, .move-to-folder-dropdown, .ant-dropdown, .carousel-btn, .project-box-select"
      )
    ) {
      return;
    }
    if (props.onCardClick(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <>
      <div
        ref={dragRef}
        className={[
          isList ? "project-box project-box-list" : "project-box",
          props.selectable ? "project-box-selectable" : "",
          props.selected ? "project-box-selected" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={isList ? handleOpen : undefined}
        onClickCapture={handleCardClickCapture}
        style={{ opacity: isDragging ? 0.4 : 1 }}
      >
        {props.selectable && (
          <button
            type="button"
            className="project-box-select"
            aria-label={props.selected ? "Deselect project" : "Select project"}
            aria-pressed={!!props.selected}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              props.onToggleSelect();
            }}
          >
            <span className="project-box-select-box">
              {props.selected && (
                <svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true">
                  <path
                    d="M2 8.5l4 4 8-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </button>
        )}
        {isList ? (
          <>
            <span className="project-box-list-title">
              {parseTitle(props.project.title)}
            </span>
            <div className="project-box-list-cell project-box-list-tags">
              {props.project.tags.slice(0, 3).map((tag, i) => (
                <TagCustom key={i} colorTag={tag.color}>{tag.name}</TagCustom>
              ))}
            </div>
            <span className="project-box-list-cell project-box-list-assets">
              {props.project.moodboards.length || 0}
            </span>
            <span className="project-box-list-cell project-box-list-date">
              {moment(props.project.date).format("MMM D, YYYY")}
            </span>
            <div className="project-box-list-actions">
              {session.get("user") &&
                session.get("user")._id &&
                (session.get("user")._id === props.project.userId ||
                  isCollaborator) && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      ref={thumbnailInputRef}
                      style={{ display: "none" }}
                      onChange={handleThumbnailUpload}
                    />
                    <i
                      className="fas fa-image trash-icon"
                      title="Change thumbnail"
                      onClick={(e) => { e.stopPropagation(); setShowThumbnailModal(true); }}
                    />
                    <i
                      className="fas fa-clone trash-icon"
                      title="Duplicate"
                      onClick={(e) => { e.stopPropagation(); handleDuplicate(e); }}
                    />
                    <i
                      className="fas fa-tags trash-icon"
                      title="Tags"
                      onClick={(e) => { e.stopPropagation(); setShowModalAddTags(true); }}
                    />
                    <i
                      className="fas fa-trash trash-icon"
                      title="Delete"
                      onClick={(e) => { e.stopPropagation(); handleDelete(e); }}
                    />
                  </>
                )}
            </div>
          </>
        ) : (
          <>
            <div
              className="project-box-thumbnail"
              onClick={handleOpen}
              style={
                carouselImages.length > 0
                  ? { ...defaultImageStyle, backgroundImage: `url(${carouselImages[carouselIndex]})` }
                  : defaultImage != null ? defaultImageStyle : emptyDefaultImageStyle
              }
            >
              {props.project.tags.length > 0 && (
                <div className="project-box-tags">
                  {props.project.tags.map((tag, i) => (
                    <TagCustom key={i} colorTag={tag.color}>{tag.name}</TagCustom>
                  ))}
                </div>
              )}
              {carouselImages.length > 1 && (
                <>
                  <button className="carousel-btn carousel-btn-left" onClick={handleCarouselPrev}>
                    <i className="fas fa-chevron-left" />
                  </button>
                  <button className="carousel-btn carousel-btn-right" onClick={handleCarouselNext}>
                    <i className="fas fa-chevron-right" />
                  </button>
                  <div className="carousel-dots">
                    {carouselImages.slice(0, 5).map((_, i) => (
                      <span
                        key={i}
                        className={`carousel-dot ${i === carouselIndex % 5 ? "carousel-dot-active" : ""}`}
                        onClick={(e) => { e.stopPropagation(); setCarouselIndex(i); }}
                      />
                    ))}
                    {carouselImages.length > 5 && (
                      <span className="carousel-dot-more">+{carouselImages.length - 5}</span>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="project-box-body">
              <div className="project-box-info" onClick={handleOpen}>
                <h3 className="project-box-title">{parseTitle(props.project.title)}</h3>
                <div className="project-box-meta">
                  <span className="project-box-meta-item">
                    {props.project.moodboards.length || 0} assets
                  </span>
                  {props.project.collaborations.length > 0 && (
                    <span className="project-box-meta-item">
                      {props.project.collaborations.length} {props.project.collaborations.length === 1 ? "collaborator" : "collaborators"}
                    </span>
                  )}
                </div>
              </div>
              <div className="project-box-footer">
                <div className="project-box-footer-left">
                  <span className="project-box-date">
                    {moment(props.project.date).format("MMM D, YYYY")}
                  </span>
                  {props.project.collaborations.length > 0 && (
                    <div className="project-box-avatars">
                      {props.project.collaborations.slice(0, 4).map((c, i) => (
                        <AvatarCustom
                          key={i}
                          size={24}
                          name={c.email}
                          style={{ borderRadius: "50%" }}
                        />
                      ))}
                      {props.project.collaborations.length > 4 && (
                        <span className="project-box-avatar-more">
                          +{props.project.collaborations.length - 4}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="project-box-actions">
                  {session.get("user") &&
                    session.get("user")._id &&
                    (session.get("user")._id === props.project.userId ||
                      isCollaborator) && (
                      <>
                        <input
                          type="file"
                          accept="image/*"
                          ref={thumbnailInputRef}
                          style={{ display: "none" }}
                          onChange={handleThumbnailUpload}
                        />
                        <i
                          className="fas fa-image trash-icon"
                          title="Change thumbnail"
                          onClick={() => setShowThumbnailModal(true)}
                        />
                        <i
                          className="fas fa-clone trash-icon"
                          title="Duplicate"
                          onClick={handleDuplicate}
                        />
                        <i
                          className="fas fa-tags trash-icon"
                          title="Tags"
                          onClick={() => setShowModalAddTags(true)}
                        />
                        {props.folders && props.folders.length > 0 && (
                          <Dropdown
                            trigger={["click"]}
                            overlay={
                              <div style={{
                                background: "#1a1a1f",
                                border: "1px solid rgba(255,255,255,0.08)",
                                borderRadius: "8px",
                                padding: "4px",
                                minWidth: "140px",
                                boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
                              }}>
                                {props.project.folderId && (
                                  <div
                                    style={{ padding: "8px 12px", fontSize: "13px", color: "#ccc", borderRadius: "5px", cursor: "pointer" }}
                                    onClick={(e) => { e.stopPropagation(); props.onMoveToFolder(props.project._id, null); }}
                                    onMouseEnter={(e) => e.target.style.background = "rgba(255,255,255,0.06)"}
                                    onMouseLeave={(e) => e.target.style.background = "transparent"}
                                  >
                                    Remove from folder
                                  </div>
                                )}
                                {props.folders.map((f) => (
                                  <div
                                    key={f._id}
                                    style={{ padding: "8px 12px", fontSize: "13px", color: "#ccc", borderRadius: "5px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                                    onClick={(e) => { e.stopPropagation(); props.onMoveToFolder(props.project._id, f._id); }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.06)"}
                                    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                                  >
                                    <FolderOutlined /> {f.name}
                                  </div>
                                ))}
                              </div>
                            }
                          >
                            <i
                              className="fas fa-folder trash-icon"
                              title="Move to folder"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </Dropdown>
                        )}
                        <i
                          className="fas fa-trash trash-icon"
                          title="Delete"
                          onClick={handleDelete}
                        />
                      </>
                    )}
                  {isDiscover && session.get("user") && (
                    <Dropdown
                      trigger={["click"]}
                      visible={showAddToProject}
                      onVisibleChange={(v) => {
                        if (v) handleOpenAddToProject();
                        else setShowAddToProject(false);
                      }}
                      overlay={
                        <div className="add-to-project-dropdown" onClick={(e) => e.stopPropagation()}>
                          <div className="add-to-project-header">Add to Project</div>
                          {userProjects.length === 0 ? (
                            <div className="add-to-project-loading"><Spin size="small" /></div>
                          ) : (
                            <div className="add-to-project-list">
                              {userProjects.map((p) => (
                                <div
                                  key={p._id}
                                  className="add-to-project-item"
                                  onClick={() => !addingToProject && handleAddToProject(p._id)}
                                >
                                  {p.defaultThumbnail ? (
                                    <div
                                      className="add-to-project-thumb"
                                      style={{ backgroundImage: `url(${p.defaultThumbnail})` }}
                                    />
                                  ) : (
                                    <div className="add-to-project-thumb add-to-project-thumb-empty" />
                                  )}
                                  <span className="add-to-project-name">
                                    {p.title || "Untitled"}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                          {addingToProject && (
                            <div className="add-to-project-loading">
                              <Spin size="small" /> Adding...
                            </div>
                          )}
                        </div>
                      }
                    >
                      <i
                        className="fas fa-ellipsis-h trash-icon"
                        title="More options"
                        style={{ opacity: 1 }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <ModalCustom
        wrapClassName="ai-modal"
        title="Add/Edit Tags"
        footer={
          <Button type="primary" onClick={hanldeAddTags}>
            Add Tag(s)
          </Button>
        }
        open={showModalAddTags}
        onOk={hanldeAddTags}
        onCancel={() => {
          setShowModalAddTags(false);
          // props.reload();
          if (edited) {
            props.getAllTags();
            setEdited(false);
          }
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "16px",
          }}
        >
          {/* {props.project.tags.map((tag) => (
            <TagCustom
              colorTag={tag.color}
              closable
              onClose={(e) => {
                e.preventDefault();
                handleRemoveTag(tag?._id);
              }}
            >
              {tag.name}
            </TagCustom>
          ))} */}

          {tags.map((tag, index) =>
            editMode.status && editMode.index === index ? (
              <WrapInput>
                <Input
                  style={{
                    width: "fit-content",
                  }}
                  defaultValue={tag.name}
                  onPressEnter={(e) => {
                    setEditMode({ status: false, index: 0 });
                    setTags(
                      tags.map((t, i) =>
                        i === index
                          ? { name: e.target.value, color: colorTagEdit }
                          : t
                      )
                    );
                    handleEditTag(tag._id, e.target.value, colorTagEdit);
                  }}
                />
                <Dropdown
                  overlay={selectColor2}
                  trigger={["click"]}
                  visible={visibleColor2}
                  onVisibleChange={setVisibleColor2}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        border: `2px solid ${colorTagEdit}`,
                      }}
                    />
                    <DownOutlined
                      style={{
                        color: "#fff",
                      }}
                    />
                  </div>
                </Dropdown>
              </WrapInput>
            ) : (
              <TagCustom
                colorTag={tag.color}
                closable
                onClose={(e) => {
                  e.preventDefault();
                  handleRemoveTag(tag?._id);
                  setEditMode({ status: false });
                }}
                onClick={() => {
                  setEditMode({ status: true, index });
                  setColorTagEdit(tag.color);
                }}
              >
                {tag.name}
              </TagCustom>
            )
          )}
        </div>
        <WrapInput>
          <Input
            // addonAfter={selectColor}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onPressEnter={hanldeAddTags}
            style={{ width: "203px" }}
          />
          <Dropdown
            overlay={selectColor}
            trigger={["click"]}
            visible={visibleColor}
            onVisibleChange={setVisibleColor}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  border: `2px solid ${colorTag}`,
                }}
              />
              <DownOutlined
                style={{
                  color: "#fff",
                }}
              />
            </div>
          </Dropdown>
        </WrapInput>
      </ModalCustom>

      <ModalCustom
        wrapClassName="ai-modal"
        title="Change Thumbnail"
        footer={null}
        open={showThumbnailModal}
        onCancel={() => setShowThumbnailModal(false)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label
              htmlFor={`thumb-upload-${props.project._id}`}
              style={{
                display: "block",
                padding: "14px",
                backgroundColor: "#2c2c2c",
                border: "1px solid #444",
                borderRadius: "8px",
                textAlign: "center",
                cursor: "pointer",
                color: "#ccc",
                fontSize: "14px",
                transition: "border-color 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.borderColor = "#888")}
              onMouseLeave={(e) => (e.target.style.borderColor = "#444")}
            >
              Upload from computer
            </label>
            <input
              id={`thumb-upload-${props.project._id}`}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                handleThumbnailUpload(e);
                setShowThumbnailModal(false);
              }}
            />
          </div>

          {getAssetImages().length > 0 && (
            <div>
              <p style={{ color: "#888", fontSize: "13px", marginBottom: "10px" }}>
                Choose from assets
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "8px",
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                {getAssetImages().map((url, i) => (
                  <div
                    key={i}
                    onClick={() => handleSelectAssetThumbnail(url)}
                    style={{
                      cursor: "pointer",
                      borderRadius: "6px",
                      overflow: "hidden",
                      border: "2px solid transparent",
                      transition: "border-color 0.15s",
                      aspectRatio: "16/10",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#4c72cd")}
                    onMouseLeave={(e) => (e.currentTarget.style.borderColor = "transparent")}
                  >
                    <img
                      src={url}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </ModalCustom>
    </>
  );
}

export default React.memo(ProjectBox);

const ModalCustom = styled(Modal)`
  .ant-modal-header {
    background-color: rgb(25, 26, 31);
  }

  .ant-modal-title {
    color: #fff;
  }

  .ant-modal-content {
    background-color: rgb(25, 26, 31);
  }

  .ant-input {
    background-color: black;
    color: white;
    &::placeholder {
      color: gray;
    }
  }

  .ant-select-selection-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline-end: 0;
  }
`;

const TagCustom = styled(Tag)`
  color: #e0e0e0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  border-color: ${(props) => props.colorTag};
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  line-height: 1.4;

  .ant-tag-close-icon {
    color: #e0e0e0;
    font-size: 12px;
  }
`;

const AvatarCustom = styled(Avatar)`
  .sb-avatar__text {
    border-radius: 50%;
  }
`;

const WrapInput = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #fff;
  border-radius: 6px;
  width: fit-content;
  background-color: #2c2c2c;
  padding-right: 12px;
  .ant-input {
    border: none;
    border-radius: 6px 0 0 6px;
    background-color: #2c2c2c;
  }
`;
